import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../Css_files/Navbar.css';
import img from "../Images/profenaa-org-logo1.png"

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleDropdownToggle = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const closeAllDropdowns = () => {
    setActiveDropdown(null);
  };

  return (
    <nav className="nav-container">
      <div className="nav-wrapper">
        {/* Logo Section - Left */}
        <div className="nav-logo">
          <Link to="/" className="nav-logo-link">
            <div className="nav-logo-icon">
              <img src={img}></img>
            </div>
            <span className="nav-logo-text">Profenaa Technologies</span><br></br>
          </Link>
          <p>Training | Internship | Placement</p>
        </div>

        {/* Desktop Navigation - Center */}
        <div className="nav-desktop">
          <ul className="nav-menu">
            <li className="nav-item">
              <Link to="/" className="nav-link"><p>Home</p></Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-link"><p>About Us</p></Link>
            </li>

            {/* Courses Dropdown */}
            <li className="nav-item nav-dropdown">
              <Link
                to="#"
                className="nav-link nav-dropdown-toggle"
                onClick={(e) => {
                  e.preventDefault();
                  handleDropdownToggle('courses');
                }}
              >
                <p>Courses</p>
                <svg className="nav-dropdown-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round" />
                </svg>
              </Link>
              <div className={`nav-dropdown-menu ${activeDropdown === 'courses' ? 'nav-dropdown-open' : ''}`}>
                <Link to="/mech" className="nav-dropdown-item">Mechanical</Link>
                <Link to="/civil" className="nav-dropdown-item">Civil</Link>
                <Link to="/ece" className="nav-dropdown-item">Ece</Link>
                <Link to="/electronics" className="nav-dropdown-item">Electronics</Link>
                <Link to="/computerscience" className="nav-dropdown-item">Computer Science</Link>
                 <Link to="/ArtsMultimedia" className="nav-dropdown-item">Arts & Multimedia</Link>
              </div>
            </li>

            <li className="nav-item">
              <Link to="/internship" className="nav-link"><p>Internship</p></Link>
            </li>
            <li className="nav-item">
              <Link to="/career" className="nav-link"><p>Careers</p></Link>
            </li>
            <li className="nav-item">
              <Link to="/blog" className="nav-link"><p>Blog</p></Link>
            </li>

            {/* Flagship Dropdown */}
            <li className="nav-item nav-dropdown">
              <Link
                to="#"
                className="nav-link nav-dropdown-toggle"
                onClick={(e) => {
                  e.preventDefault();
                  handleDropdownToggle('flagship');
                }}
              >
                <p>Flagship</p>
                <svg className="nav-dropdown-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round" />
                </svg>
              </Link>
              <div className={`nav-dropdown-menu ${activeDropdown === 'flagship' ? 'nav-dropdown-open' : ''}`}>
                <Link to="/mou" className="nav-dropdown-item">Mou</Link>
                <Link to="/gallery" className="nav-dropdown-item">Gallery</Link>
                <Link to="/placement" className="nav-dropdown-item">Job Updates</Link>
                <Link to="/certification" className="nav-dropdown-item">Certification Verification</Link>
              </div>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link">Contact Us</Link>
            </li>
          </ul>
        </div>

        {/* CTA Button Section - Right */}
        <div className="nav-cta-section">
          <a href="https://forms.gle/EbDaNAqS6BYRNj4n8" className="nav-cta-button">Enroll Now</a>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="nav-mobile-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={`nav-hamburger ${isMobileMenuOpen ? 'nav-hamburger-open' : ''}`}></span>
          <span className={`nav-hamburger ${isMobileMenuOpen ? 'nav-hamburger-open' : ''}`}></span>
          <span className={`nav-hamburger ${isMobileMenuOpen ? 'nav-hamburger-open' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`nav-mobile-menu ${isMobileMenuOpen ? 'nav-mobile-menu-open' : ''}`}>
        <ul className="nav-mobile-list">
          <li className="nav-mobile-item">
            <Link to="/" className="nav-mobile-link" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
          </li>
          <li className="nav-mobile-item">
            <Link to="/about" className="nav-mobile-link" onClick={() => setIsMobileMenuOpen(false)}>About Us</Link>
          </li>
          <li className="nav-mobile-item">
            <button
              className="nav-mobile-dropdown-toggle"
              onClick={() => handleDropdownToggle('mobilecourses')}
            >
              Courses
              <svg className="nav-dropdown-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <div className={`nav-mobile-dropdown ${activeDropdown === 'mobilecourses' ? 'nav-mobile-dropdown-open' : ''}`}>
               <Link to="/mech" className="nav-dropdown-item">Mechanical</Link>
                <Link to="/civil" className="nav-dropdown-item">Civil</Link>
                <Link to="/ece" className="nav-dropdown-item">Ece</Link>
                <Link to="/electronics" className="nav-dropdown-item">Electronics</Link>
                <Link to="/computerscience" className="nav-dropdown-item">Computer Science</Link>
                 <Link to="/ArtsMultimedia" className="nav-dropdown-item">Arts & Multimedia</Link>
              </div>
          </li>
          <li className="nav-mobile-item">
            <Link to="/internship" className="nav-mobile-link" onClick={() => setIsMobileMenuOpen(false)}>Internship</Link>
          </li>
          <li className="nav-mobile-item">
            <Link to="/career" className="nav-mobile-link" onClick={() => setIsMobileMenuOpen(false)}>Careers</Link>
          </li>
          <li className="nav-mobile-item">
            <Link to="/blog" className="nav-mobile-link" onClick={() => setIsMobileMenuOpen(false)}>Blog</Link>
          </li>
          <li className="nav-mobile-item">
            <button
              className="nav-mobile-dropdown-toggle"
              onClick={() => handleDropdownToggle('mobileflagship')}
            >
              Flagship
              <svg className="nav-dropdown-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <div className={`nav-mobile-dropdown ${activeDropdown === 'mobileflagship' ? 'nav-mobile-dropdown-open' : ''}`}>
                <Link to="/mou" className="nav-dropdown-item">Mou</Link>
                <Link to="/gallery" className="nav-dropdown-item">Gallery</Link>
                <Link to="/placement" className="nav-dropdown-item">Job Updates</Link>
                <Link to="/flagship/research-center" className="nav-dropdown-item">Certification Verification</Link>
            </div>
          </li>
          <li className="nav-mobile-item">
            <Link to="/contact" className="nav-mobile-link" onClick={() => setIsMobileMenuOpen(false)}>Contact Us</Link>
          </li>
          <li className="nav-mobile-item">
           <a href="https://forms.gle/EbDaNAqS6BYRNj4n8" className="nav-mobile-cta-button">Enroll Now</a>
          </li>
        </ul>
      </div>

      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && <div className="" onClick={() => setIsMobileMenuOpen(false)}></div>}
    </nav>
  );
};

export default Navbar;
